// CapaSource-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * CapaSource-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing capaSource module code
 */
export const createCapaSourceValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateCapaSourceData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createCapaSourceValidation;
